"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingCartChangesType = void 0;
var ShoppingCartChangesType;
(function (ShoppingCartChangesType) {
    ShoppingCartChangesType["ItemUnavailable"] = "ITEM_UNAVAILABLE";
    ShoppingCartChangesType["OutOfStock"] = "OUT_OF_STOCK";
    ShoppingCartChangesType["PriceDecrease"] = "PRICE_DECREASE";
    ShoppingCartChangesType["PriceIncrease"] = "PRICE_INCREASE";
    ShoppingCartChangesType["StockDecreased"] = "STOCK_DECREASED";
})(ShoppingCartChangesType || (exports.ShoppingCartChangesType = ShoppingCartChangesType = {}));
//# sourceMappingURL=shopping-cart.js.map